import type { FC, ReactNode } from "react";
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { usePortal } from "@litres-libs/global-hooks";
import type { EModalIds } from "./types";
import styles from "./Modal.module.scss";

interface IModalProps {
  children: ReactNode;
  id: EModalIds;
}

export const Modal: FC<IModalProps> = ({ children, id }) => {
  const modal = usePortal(id);

  useEffect(() => {
    if (document) {
      document.body.style.overflow = "hidden";

      return (): void => {
        document.body.style.removeProperty("overflow");
      };
    }
  }, []);

  if (!children || !modal) {
    return null;
  }

  return createPortal(
    <div className={styles.wrapper} data-testid="header__modal">
      {children}
    </div>,
    modal
  );
};
